export default function SectionHeadingDefault({ children }) {
  return (
    <div className='md:border-b text-center md:text-left md:border-theme-intel-2020-e-gray-s1 pb-5'>
      <h2 className='text-srt-3xl font-intel-one-display font-medium text-theme-intel-2020-e-gray-t1 md:text-theme-intel-2020-e-gray-s1'>
        {children}
      </h2>
    </div>
  );
}
